import { DateTimeUtility } from '../utility/date-time.utility';
import { BaseResponse } from './base-response.model';
import { DiffLog, DiffLogJSON } from './diff-log.model';

export interface ChangeLogsResponse extends BaseResponse {
	message: string;
	changeLogs: ChangeLogJSON[];
}

export interface ChangeLogJSON {
	id: number;
	type: string;
	timestamp: string;
	userId: number;
	username: string;
	dbTableName: string;
	dbTablePrimary: string;
	rowId: number;
	diffLogs: DiffLogJSON[];
}

export class ChangeLog {
	constructor(
		public id: number,
		public type: string,
		public timestamp: Date,
		public userId: number,
		public username: string,
		public dbTableName: string,
		public dbTablePrimary: string,
		public rowId: number,
		public diffLogs: DiffLog[]
	) {}

	get changeType(): string {
		return this.diffLogs?.length > 0 ? this.diffLogs[0].changeType : null;
	}

	static fromJSON(json: ChangeLogJSON): ChangeLog {
		return Object.assign(Object.create(ChangeLog.prototype), json, {
			timestamp: json.timestamp
				? DateTimeUtility.fromDatabaseDatetime(json.timestamp)
				: null,
			diffLogs: json.diffLogs
				? json.diffLogs.map((diffLogJSON) =>
						DiffLog.fromJSON(diffLogJSON)
					)
				: [],
		});
	}
}
